import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Employee from './pages/Employee';
import SuperAdmin from './pages/SuperAdmin';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import './App.css';
import ErrorBoundary from './ErrorBoundry';

function App() {
  return (
    <Router>
      <ErrorBoundary>
      <div>
        <Routes>
          {/* Define specific routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Role-protected routes - only accessible to users with specific roles */}
          <Route 
            path="/admin" 
            element={
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Admin />
              </RoleProtectedRoute>
            } 
          />
          <Route 
            path="/employee" 
            element={
              <RoleProtectedRoute allowedRoles={['employee', 'admin']}>
                <Employee />
              </RoleProtectedRoute>
            } 
          />
          <Route 
            path="/superadmin" 
            element={
              <RoleProtectedRoute allowedRoles={['superadmin']}>
                <SuperAdmin />
              </RoleProtectedRoute>
            } 
          />

          {/* Redirect to login if no route matches */}
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </div>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
